module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7yi75"))).then(() => parcelRequire('fThBo'));